<template>
  <ValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :name="name"
    :vid="vid"
    :immediate="immediate"
  >
    <label v-if="label">
      {{ label }}
    </label>
    <textarea
      ref="input"
      v-model="iValue"
      step="any"
      :name="name"
      :placeholder="placeholder"
      :type="type"
      :readonly="readonly"
      :disabled="disabled"
      :autocomplete="autocomplete"
      class="uk-width-1-1 uk-input uk-text-large"
      :class="{
        'uk-form-danger': errors.length
      }"
      :rows="rows"
      @change="handleChanged"
    />
    <span class="error"
      v-if="errors.length"
    >
      {{ errors[0] }}
    </span>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      type: [String, Number],
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    immediate: {
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    sublabel: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [String, Object],
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    hideInput: {
      type: [String, Boolean],
      default: false,
    },
    explain: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 3
    }
  },

  computed: {
    iValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (this.type !== 'file') {
          if (this.rules && this.rules.match(/(email|customurl|subdomain)/)) {
            newValue = newValue.replace(/\s/, '')
          }

          this.$emit('input', newValue)
        }
      },
    },
  },

  methods: {
    handleChanged() {
      if (this.type === 'file' && this.$refs.input.files.length) {
        this.$emit('changed', this.$refs.input.files[0])
      } else {
        this.$emit('changed', this.iValue)
      }
    },
  },
}
</script>
